import type { UpdateDocuSignRecipient } from '@urbanx/agx.docusign.client';
import type { ManualDocuSignUpdateRecipientDetails } from '@urbanx/agx.support.client';

type RecipientUpdateStatus = 'signed' | 'completed';

export const buildRecipientUpdatePayload = (
  recipient: ManualDocuSignUpdateRecipientDetails,
  status: RecipientUpdateStatus,
  signedAt: Date
): UpdateDocuSignRecipient => ({
  recipientId: recipient.recipientUniqueIdentifier,
  status,
  signedUtc: recipient.signedUtc ?? signedAt.toISOString(),
  deliveredUtc: recipient.deliveredUtc,
  sentUtc: recipient.sentUtc,
});
